/**
 * 资源元数据服务
 * 定义接口
 */
const IEMapService = require('./IEMapService');
/**
 * @classdesc 资源元数据服务接口
 * @alias G.service.IResourceMetaService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IResourceMetaService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 获取表元数据
     * @param {String} table 表名 
     */
    getTable(table) {}

}
module.exports = IResourceMetaService;